<script>
import {defineComponent} from 'vue'
import {IonSpinner} from "@ionic/vue";

export default defineComponent({
  name: "PageLoading",
  components: {IonSpinner}
})
</script>

<template>
  <div class="pageLoadingDiv">
    <div class="items"><ion-spinner class="center-item" name="crescent"></ion-spinner>&nbsp;&nbsp;&nbsp; کمی صبر کنید ...</div>
  </div>
</template>

<style scoped>
.pageLoadingDiv
{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  background: #000000B3;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>